module.exports = __webpack_public_path__ + "static/media/consorcio-legumbres.7e65110e.jpg";